import { render, staticRenderFns } from "./NotificationMethodBase.vue?vue&type=template&id=1bd1df42&scoped=true&"
import script from "./NotificationMethodBase.vue?vue&type=script&lang=js&"
export * from "./NotificationMethodBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1df42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
